/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";

// eslint-disable-next-line import/prefer-default-export
export const updateExistingAssignmentDetails = async ({ applicationId, reqBody }: any) => {
  try {
    const response: any = await axiosInstance.post(API_URLS.setAssignment, reqBody, {
      params: {
        ...(applicationId && { id: applicationId })
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};
